/* NX1 PROJECT | Glaze | slide-down search with live suggestions from Shopify predictive search. No dependencies. */
(function () {
  'use strict';
  var panel = document.querySelector('[data-nx-search]');
  if (!panel) return;
  var cfg = JSON.parse(panel.querySelector('[data-nx-search-config]').textContent);
  var input = panel.querySelector('input[type=search]');
  var results = panel.querySelector('[data-nx-search-results]');
  var idle = results.innerHTML;
  var timer = null, ctrl = null, lastFocus = null, closeTimer = null;

  function esc(s) { var d = document.createElement('span'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(cfg.locale || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP' }).format(n); }
    catch (e) { return n.toFixed(2); }
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function setExpanded(v) { document.querySelectorAll('[data-nx-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  function isOpen() { return panel.classList.contains('is-open'); }

  function open() {
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    document.querySelectorAll('details.nx-drawer[open]').forEach(function (d) { d.removeAttribute('open'); });
    if (window.NX1Cart && document.querySelector('[data-nx-cart].is-open')) window.NX1Cart.close();
    panel.hidden = false;
    void panel.offsetHeight; /* let the browser paint the start state so the slide runs */
    panel.classList.add('is-open');
    setExpanded(true);
    setTimeout(function () { input.focus(); }, 60);
  }
  function close(restore) {
    panel.classList.remove('is-open');
    setExpanded(false);
    closeTimer = setTimeout(function () { if (!isOpen()) panel.hidden = true; }, 220);
    if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var hidden = window.hiddenProductHandles || [];
    var products = (r.products || []).filter(function (p) {
      return hidden.indexOf(p.handle) === -1;
    }).slice(0, 4);
    var pages = (r.pages || []).concat(r.articles || []);
    if (!products.length && !pages.length) {
      results.innerHTML = '<p class="nx-search__empty">' + esc(cfg.none.replace('[terms]', q)) + '</p>' + idle;
      return;
    }
    var html = '<div class="nx-search__cols"><div>';
    if (products.length) {
      html += '<p class="nx-search__label">' + esc(cfg.productsLabel) + '</p><ul class="nx-search__products">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return '<li class="nx-search__product"><a href="' + esc(p.url) + '">' +
          '<span class="nx-search__img">' + (img ? '<img src="' + esc(sized(img, 400)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="nx-search__name">' + esc(p.title) + '</span>' +
          '<span class="nx-search__price">' + (p.available === false ? esc(cfg.soldOut) : money(p.price)) + '</span>' +
        '</a></li>';
      }).join('') + '</ul>';
    }
    html += '</div><div>';
    if (pages.length) {
      html += '<p class="nx-search__label">' + esc(cfg.pagesLabel) + '</p><ul class="nx-search__links">' + pages.map(function (p) {
        var kind = String(p.url || '').indexOf('/blogs/') > -1 ? cfg.articleLabel : cfg.pageLabel;
        return '<li><a href="' + esc(p.url) + '"><small>' + esc(kind) + '</small>' + esc(p.title) + '</a></li>';
      }).join('') + '</ul>';
    }
    html += '<p style="margin:16px 0 0"><a class="nx-search__all" href="' + esc(cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">' + esc(cfg.allLabel.replace('[terms]', q)) + ' &rarr;</a></p>';
    html += '</div></div>';
    results.innerHTML = html;
  }

  function suggest() {
    var q = input.value.trim();
    if (ctrl) ctrl.abort();
    if (q.length < 2) { results.innerHTML = idle; return; }
    var lim = Math.min(10, 4 + (window.hiddenProductHandles || []).length);
    var url = cfg.url + '?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,page,article&resources%5Blimit%5D=' + lim + '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (input.value.trim() === q) render(q, j); })
      .catch(function () {});
  }

  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 220); });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nx-search-open]');
    if (opener) { e.preventDefault(); if (isOpen()) close(); else open(); return; }
    if (e.target.closest('[data-nx-search-close]')) { e.preventDefault(); close(); return; }
    if (isOpen() && !panel.contains(e.target)) close(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
})();